import type { AnyCircuitElement, PcbRenderLayer } from "circuit-json"
import { CircuitToCanvasDrawer } from "circuit-to-canvas"
import type { Matrix } from "transformation-matrix"

export function isPcbPanelElement(element: AnyCircuitElement) {
  return element.type === "pcb_panel"
}

export function drawPcbPanelElements({
  canvas,
  elements,
  layers,
  realToCanvasMat,
  drawSoldermask,
}: {
  canvas: HTMLCanvasElement
  elements: AnyCircuitElement[]
  layers: PcbRenderLayer[]
  realToCanvasMat: Matrix
  drawSoldermask?: boolean
}) {
  const drawer = new CircuitToCanvasDrawer(canvas)

  drawer.realToCanvasMat = realToCanvasMat

  const pcbPanelElements = elements.filter(isPcbPanelElement)

  for (const element of pcbPanelElements) {
    drawer.drawElements([element], { layers })
  }
}
